import { render, staticRenderFns } from "./creat-button.vue?vue&type=template&id=af160722&scoped=true"
import script from "./creat-button.vue?vue&type=script&lang=js"
export * from "./creat-button.vue?vue&type=script&lang=js"
import style0 from "./creat-button.vue?vue&type=style&index=0&id=af160722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af160722",
  null
  
)

export default component.exports